import { QueryClient } from '@tanstack/react-query';

/**
 * Defaults escolhidos para WebView do Capacitor (PRD §4.3).
 *
 * `refetchOnWindowFocus` fica DESLIGADO: no mobile, cada alternância de app dispara focus, e
 * cada chamada à bridge nativa tem custo. Refetch agressivo em rede móvel gasta bateria e
 * dados sem ganho percebido pelo usuário.
 *
 * `refetchOnReconnect` fica LIGADO: voltar de um túnel ou do modo avião é o momento em que os
 * dados em cache estão de facto desatualizados e o usuário espera vê-los atualizar.
 *
 * `mutations.retry: 0` é deliberado: repetir uma mutação sem idempotência garantida pode
 * duplicar efeito — um agendamento a mais, uma cobrança a mais. Retry de mutação, quando
 * fizer sentido, é decidido por caso, nunca por default global.
 */
export const QUERY_DEFAULTS = {
  staleTime: 60_000,
  gcTime: 5 * 60_000,
  retry: 2,
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
} as const;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { ...QUERY_DEFAULTS },
      mutations: { retry: 0 },
    },
  });
}

export const queryClient = createQueryClient();
